import type { TeamPerformanceResponse, TeamTotals, HourlyHeatmapPoint } from '@/types/teamPerformance'

/**
 * Données d'exemple affichées floutées derrière le verrou « Inclus dans
 * Business » : le serveur refuse les vraies (403), on montre à quoi ressemble
 * la page une fois débloquée. Chiffres plausibles, pas ceux de l'entreprise.
 */
function totals(f: number): TeamTotals {
  return {
    calls_total: Math.round(184 * f),
    calls_inbound: Math.round(121 * f),
    calls_outbound: Math.round(63 * f),
    missed_total: Math.round(14 * f),
    talk_time_seconds: Math.round(5 * 3600 * f),
    sms_sent: Math.round(57 * f),
    appointments_created: Math.round(9 * f),
    voicemails_listened: Math.round(11 * f),
    answer_rate_pct: 89,
  }
}

function serie(base: number) {
  const jours = ['2026-09-14', '2026-09-15', '2026-09-16', '2026-09-17', '2026-09-18', '2026-09-19', '2026-09-20']
  const forme = [0.8, 1.1, 1.0, 1.3, 1.2, 0.5, 0.3]
  return jours.map((date, i) => ({ date, value: Math.round(base * forme[i]) }))
}

function heatmap(): HourlyHeatmapPoint[] {
  const points: HourlyHeatmapPoint[] = []
  for (let day = 0; day < 7; day++) {
    for (let hour = 8; hour < 19; hour++) {
      const ouvrable = day < 5 ? 1 : 0.2
      const pic = hour === 10 || hour === 14 ? 2 : 1
      points.push({ day, hour, count: Math.round(3 * ouvrable * pic) })
    }
  }
  return points
}

const agent = (user_id: number, name: string, f: number) => ({
  user_id,
  name,
  role: 'AGENT' as const,
  avatar_url: null,
  calls_inbound_answered: Math.round(40 * f),
  calls_outbound: Math.round(21 * f),
  calls_missed_rung: Math.round(4 * f),
  calls_total: Math.round(65 * f),
  answer_rate_pct: Math.round(84 + 8 * f),
  talk_time_seconds: Math.round(1.7 * 3600 * f),
  avg_handle_time_seconds: Math.round(190 + 40 * f),
  sms_sent: Math.round(19 * f),
  appointments_created: Math.round(3 * f),
  voicemails_listened: Math.round(4 * f),
  calls_total_previous: Math.round(58 * f),
  talk_time_seconds_previous: Math.round(1.5 * 3600 * f),
})

export const APERCU_ANALYTICS: TeamPerformanceResponse = {
  period: { key: 'cette_semaine', start: '2026-09-14', end: '2026-09-20' },
  previous_period: { start: '2026-09-07', end: '2026-09-13' },
  team_totals: totals(1),
  team_totals_previous: totals(0.9),
  daily_series: {
    calls_total: serie(30),
    calls_inbound: serie(20),
    calls_outbound: serie(10),
    missed_total: serie(2),
    talk_time_seconds: serie(3000),
    sms_sent: serie(9),
    appointments_created: serie(1.5),
    voicemails_listened: serie(2),
  },
  hourly_heatmap: { hourly_all: heatmap(), hourly_missed: heatmap().map((p) => ({ ...p, count: Math.round(p.count / 4) })), timezone: 'America/Toronto' },
  agents: [agent(1, 'Sophie Tremblay', 1.2), agent(2, 'Marc Gagnon', 1), agent(3, 'Amina Diallo', 0.8)],
}
